// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"8ba861db","952":"143e353b"}[chunkId] + ".chunk.js";
};